import AdminRoutes from "./admin_routes/AdminRoutes";
import AuthRoutes from "./auth_routes/AuthRoutes";
import CARoutes from "./ca_routes/CARoutes";
import PublicRoutes from "./public_routes/PublicRoutes";
import UserRoutes from "./user_routes/UserRoutes";

import NotFoundPage from "../pages/other_pages/NotFoundPage";
import BaseIconShowPage from "../components/svg_icons/BaseIconShowPage";

const otherRoutes = [
    // Catch-all route for 404
    { path: '*', element: <NotFoundPage /> },

    // Show icons with Custom names
    { path: 'base-icon-show-page', element: <BaseIconShowPage /> },
];

const routes = [
    ...AdminRoutes, ...AuthRoutes, ...CARoutes,
    ...PublicRoutes, ...UserRoutes, ...otherRoutes,
    // other-routes
];

export default routes;
